<template>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form class="form" @submit.prevent="handleSubmit(summit)" autocomplete="off">
            <div class="row">
                <div class="col-md-6">
                    <p class="h4 font-weight-bold">Thông tin khách hàng</p>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Họ và tên <span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="name"
                            name="Họ và tên"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <el-input
                                :disabled="is_show"
                                filterable
                                class="w-100"
                                placeholder="Họ và tên"
                                v-model="contract.name"
                            ></el-input>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Số điện thoại<span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="phone"
                            name="Số điện thoại"
                            :rules="{ required: true, regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                            v-slot="{ errors }"
                        >
                            <el-input
                                @input="checkUniquePhone"
                                filterable
                                class="w-100"
                                placeholder="Số điện thoại"
                                v-model="contract.phone"
                            ></el-input>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Số điện thoại khác<span class="text-danger"></span
                        ></label>
                        <ValidationProvider
                            vid="phone_other"
                            name="Nhập số điện thoại khác"
                            :rules="{ required: false, regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                            v-slot="{ errors }"
                        >
                            <el-input
                                v-model="contract.phone_other"
                                :disabled="is_show"
                                filterable
                                class="w-100"
                                placeholder="Nhập số điện thoại khác"
                            ></el-input>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Email<span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="email"
                            name="Nhập Email"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <el-input
                                :disabled="is_show"
                                v-model="contract.email"
                                filterable
                                class="w-100"
                                placeholder="Nhập Email"
                            ></el-input>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Ngày sinh<span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="birthday"
                            name="Ngày sinh"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <el-date-picker
                                :disabled="is_show"
                                @change="handleBirthday"
                                v-model="contract.birthday"
                                type="date"
                                format="dd-MM-yyyy"
                                placeholder="Nhập ngày sinh"
                            >
                            </el-date-picker>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label">Căn cước công dân</label>
                        <ValidationProvider vid="cccd" name="Căn cước công dân" :rules="{ required: false,regex: /^[0-9]{9}$|^[0-9]{12}$/ }" v-slot="{ errors }">
                            <el-input :disabled="is_show" v-model="contract.cccd" filterable class="w-100" placeholder="Nhập căn cước công dân"></el-input>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <div class="row col-md-12 p-0">
                            <div class="col-md-6">
                                <label class="form-label col-form-label">Tỉnh, thành phố<span class="text-danger">*</span></label>
                                <ValidationProvider vid="province_id" name="Tỉnh, thành phố" rules="required" v-slot="{ errors }">
                                    <el-select
                                        filterable
                                        :disabled="is_show"
                                        v-model="contract.province_id"
                                        placeholder="Tỉnh, thành phố"
                                        clearable
                                        @input="changeDistricts"
                                    >
                                        <el-option
                                            v-for="item in provinces"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>

                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{ errors[0] }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label col-form-label">Xã, phường <span class="text-danger">*</span></label>
                                <ValidationProvider vid="district_id" name="Xã, phường" rules="required" v-slot="{ errors }">
                                    <el-select
                                        filterable
                                        :disabled="!contract.province_id"
                                        v-model="contract.district_id"
                                        placeholder="Xã, phường"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in districts"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                    <div class="fv-plugins-message-container">
                                        <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                            {{ errors[0] }}
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label">Số nhà, đường</label>
                        <el-input :disabled="is_show" v-model="contract.sub_district" filterable class="w-100"
                                  placeholder="Nhập địa chỉ"></el-input>
                        <span style="margin-top: 5px">Lưu ý: Thông tin này được sử dụng để gửi quà, box, sách cho khách hàng. Vui lòng nhập chính xác.</span>
                    </div>
                    <p class="h4 font-weight-bold mb-4">Tạo đơn hàng</p>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Trung tâm đăng ký học<span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="center_id"
                            name="Trung tâm"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <el-select
                                filterable
                                :disabled="is_show || loadingBranches || loadingCourses"
                                :loading="loadingBranches"
                                v-model="contract.center_id"
                                placeholder="Chọn trung tâm"
                                clearable
                                @change="handleCenter"
                            >
                                <el-option
                                    v-for="item in centers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Chi nhánh học tập<span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="branch_id"
                            name="Chi nhánh"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <el-select
                                filterable
                                :disabled="
                                    is_show ||
                                    !contract.center_id ||
                                    loadingBranches ||
                                    loadingCourses
                                "
                                :loading="loadingBranches || loadingCourses"
                                v-model="contract.branch_id"
                                placeholder="Chọn chi nhánh"
                                clearable
                                @change="handleBranch"
                            >
                                <el-option
                                    v-for="item in branches"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <p class="h4 font-weight-bold mb-4">Danh sách khóa học </p>
                    <div v-for="(item, index) in contract.courses" :key="index" class="courses">
                        <div class="form-group">
                            <label class="form-label col-form-label"
                            >Khóa học {{ index + 1 }}<span class="text-danger">*</span></label
                            >
                            <div class="row">
                                <div class="col-md-10">
                                    <ValidationProvider
                                        :vid="'courses.' + index + '.id'"
                                        name="Khóa học"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <el-select
                                            filterable
                                            :disabled="
                                                is_show ||
                                                !contract.branch_id ||
                                                loadingCourses
                                            "
                                            :loading="loadingCourses"
                                            v-model="item.id"
                                            placeholder="Chọn khóa học"
                                            clearable
                                            @change="handleCourse(item)"
                                        >
                                            <el-option
                                                v-for="item in courses"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                                :disabled="item.disabled"
                                            >
                                            </el-option>
                                        </el-select>
                                        <div class="fv-plugins-message-container">
                                            <div
                                                data-field="name"
                                                data-validator="notEmpty"
                                                class="fv-help-block"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div
                                    v-if="index != 0"
                                    class="mt-2 col-md-2 cursor-pointer"
                                    @click="removeCourse(index)"
                                >
                                    <i class="el-icon-delete font-weight-bold text-danger fa-lg"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-button
                        class="mt-4"
                        @click="addNewCourse()"
                        size="mini"
                        type="primary"
                        icon="el-icon-plus"
                        :disabled="is_show || !contract.branch_id || loadingCourses"
                    >Thêm khóa
                    </el-button>
                    <!-- Dịch vụ bảo hành -->
                    <div v-if="isWarrantyServiceCenter(contract.center_id)" class="my-4">
                        <p class="h4 font-weight-bold mb-4">Chọn Dịch vụ bảo hành</p>
                        <WarrantySelect
                            :disabled="is_show"
                            :selected-id="contract.service_id"
                            @selected="setSelectedWarrantyService"
                        />
                    </div>
                    <div class="form-group">
                        <label class="form-label col-form-label"
                        >Hình thức hoàn thành học phí<span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                            vid="tuition_payment_id"
                            name="Hình thức hoàn thành học phí"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <el-select
                                filterable
                                :disabled="is_show"
                                v-model="contract.tuition_payment_id"
                                placeholder="Chọn phương thức thanh toán"
                                @input="handleTuitionPayment"
                                clearable
                            >
                                <el-option
                                    v-for="item in tuitions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                            <div class="fv-plugins-message-container">
                                <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                    {{ errors[0] }}
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div v-if="contract.tuition_payment_id == 2">
                        <p>
                            Với hình thức trả góp ngân hàng, vui lòng kiểm tra thông tin tín dụng của
                            khách hàng/người giám hộ.
                        </p>
                        <p class="font-weight-light" style="font-size: 12px">
                            Lưu ý: Trường hợp không đủ điều kiện trả góp ngân hàng, tư vấn viên tư vấn
                            lại hình thức hoàn thành học phí cho khách hàng và chỉnh sửa lại thông tin
                            liên quan trong phiếu đăng ký học tập.
                        </p>
                        <a
                            href="javascript:0;"
                            class="text-primary"
                            @click="checkCicDialogVisible = true"
                        >Xem hướng dẫn check CIC</a
                        >
                    </div>
                    <div>
                        <label class="form-label col-form-label">Voucher & Quà tặng</label>
                    </div>
                    <div class="col-md-12 d-flex">
                        <!--            <el-badge :value="numberGift" class="item" type="success">-->
                        <!--              <el-button @click="openListGift()" size="small">Chọn voucher & quà tặng</el-button>-->
                        <!--            </el-badge>-->
                        <el-badge :value="promotionTotal" class="item" type="success">
                            <el-button @click="viewVoucher()" size="small">
                                Chọn voucher & quà tặng</el-button
                            >
                        </el-badge>
                        <div
                            class="rounded-circle bg-danger text-white ml-1 d-flex justify-content-center align-items-center"
                            style="width: 20px; height: 20px"
                        >
                            {{ listVoucher.length ?? 0 }}
                        </div>
                    </div>
                    <div v-for="(item, index) in list_promotions_selected" :key="'a' + index">
                        <div class="promotions row mt-4" v-if="list_promotions_selected.length > 0">
                            <div class="col-md-5 font-weight-bold">
                                <span v-if="item.type">Quy đổi quà tặng - {{ item.name }}</span>
                                <span v-if="item.type == 0">{{ item.name }}</span>
                                <span v-if="item.type == 0">(Voucher)</span>
                            </div>
                            <div class="col-md-6 font-weight-bold">
                <span v-if="item.unit === 0">
                  <span class="badge badge-success"> {{ item.value }}%</span>
                </span>
                                <span v-else>
                  <span class="badge badge-success">{{ item.value | formatVND }}</span>
                </span>
                            </div>
                            <div class="col-md-1">
                                <!--								<i class="el-icon-delete mt-2 font-weight-bold text-danger fa-lg cursor-pointer"-->
                                <!--									 @click="unPickPromotions(item)"></i>-->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="parent" v-if="!contract.is_older">
                        <p class="h4 font-weight-bold">
                            Thông tin người giám hộ
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="Trường hợp khách hàng dưới 15 tuổi, người giám hộ là người xác thực phiếu đăng ký học tập"
                                placement="top"
                            >
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <div class="form-group">
                            <label class="form-label col-form-label d-block"
                            >Mối quan hệ<span class="text-danger"></span>
                            </label>
                            <ValidationProvider
                                vid="type"
                                name="Mối quan hệ"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <el-radio-group v-model="contract.parent.type" size="small">
                                    <el-radio-button label="bo">Bố</el-radio-button>
                                    <el-radio-button label="me">Mẹ</el-radio-button>
                                    <el-radio-button label="khac">Khác</el-radio-button>
                                </el-radio-group>
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group" v-if="contract.parent.type === 'khac'">
                            <label class="form-label col-form-label"
                            >Nhập mối quan hệ với khách hàng<span class="text-danger">*</span></label
                            >
                            <ValidationProvider
                                vid="other_value"
                                name="Mối quan hệ khác"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <el-input
                                    :disabled="is_show"
                                    filterable
                                    class="w-100"
                                    placeholder="Nhập mối quan hệ với khách hàng"
                                    v-model="contract.parent.other_value"
                                >
                                </el-input>
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label"
                            >Họ tên người giám hộ<span class="text-danger">*</span></label
                            >
                            <ValidationProvider
                                vid="parent.name"
                                name="Họ và tên người giám hộ"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <el-input
                                    filterable
                                    :disabled="is_show"
                                    class="w-100"
                                    placeholder="Họ tên người giám hộ"
                                    v-model="contract.parent.name"
                                ></el-input>
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label"
                            >Số điện thoại người giám hộ<span class="text-danger">*</span></label
                            >
                            <ValidationProvider
                                vid="parent.phone"
                                name="Số điện thoại người giám hộ"
                                :rules="{ required: true, regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                                v-slot="{ errors }"
                            >
                                <el-input
                                    @input="checkUniquePhone"
                                    :disabled="is_show"
                                    filterable
                                    class="w-100"
                                    placeholder="Số điện thoại người giám hộ"
                                    v-model="contract.parent.phone"
                                ></el-input>
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <label class="form-label col-form-label"
                            >Số điện thoại người giám hộ khác(Nếu có)<span class="text-danger"></span
                            ></label>
                            <ValidationProvider
                                vid="name"
                                name="Số điện thoại người giám hộ khác(nếu có)"
                                :rules="{ required: false, regex: /^(0[3|5|7|8|9])+([0-9]{8})$/ }"
                                v-slot="{ errors }"
                            >
                                <el-input
                                    filterable
                                    class="w-100"
                                    :disabled="is_show"
                                    placeholder="Số điện thoại người giám hộ"
                                    v-model="contract.parent.phone_other"
                                ></el-input>
                                <div class="fv-plugins-message-container">
                                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                    <p class="h4 font-weight-bold">Thông tin đơn hàng</p>
                    <!-- Khóa học-->
                    <p class="h5 font-weight-bold">Danh sách khóa học</p>
                    <div v-if="contract.courses.length">
                        <hr />
                        <div
                            class="d-flex justify-content-between mb-2"
                            v-for="(item, index) in contract.student_register_courses"
                            :key="'b' + index"
                        >
              <span>
                <i class="el-icon-menu mr-4"></i>
                <span class="font-weight-bold">{{ item.course.name }}</span>
              </span>
                            <span class="font-weight-bold">{{ item.fee | formatVND }}</span>
                        </div>
                        <!--End-->
                    </div>
                    <div v-else>
                        <p class="font-weight-bold text-danger">Không có khóa học</p>
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between">
                        <p class="h5">Tổng giá gốc</p>
                        <p class="h5">{{ contract.total | formatVND }}</p>
                    </div>
                    <div class="d-flex justify-content-between" v-if="customer?.student_deposit_log?.status == 2">
                        <p class="h5">Đã thanh toán</p>
                        <p class="h5">{{ customer?.total_deposit_log | formatVND }}</p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p class="h5">Tổng khuyến mại </p>
                        <p class="text-success h5">{{ contract.total_promotions | formatVND }}</p>
                    </div>
                    <!-- Gói dịch vụ bảo hành -->
                    <div v-if="isShowWarrantySummary">
                        <hr />
                        <p class="h5 font-weight-bold">Gói dịch vụ bảo hành</p>
                        <hr />
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <span>
                                <i class="el-icon-menu mr-4"></i>
                                <span class="font-weight-bold">{{ contract.service.name }}</span>
                            </span>
                            <span class="font-weight-bold">{{ warrantyServiceAmount | formatVND }}</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p class="font-weight-bold h4">Tổng thanh toán</p>
                        <p class="text-danger h4">{{ finalTotalNeed | formatVND }}</p>
                    </div>
                    <hr />
                    <div class="gift" v-if="gift_select.length">
                        <p class="font-weight-bold h4">Quà tặng:</p>
                        <div
                            v-for="gift in gift_select"
                            :key="gift.id"
                        >
                            <el-input
                                :value="gift?.name"
                                autosize
                                class="mb-2"
                                type="textarea"
                                placeholder="Quà tặng"
                                style="white-space: pre"
                                disabled
                            />
                        </div>

                    </div>

                    <div class="first_payment_information mt-4">
                        <p class="font-weight-bold h2">Thông tin thanh toán</p>
                        <label class="font-weight-bold h5"
                        >Chọn cách thức thanh toán<span class="text-danger">*</span></label
                        >
                        <div class="form-group">
                            <div class="form-group">
                                <ValidationProvider
                                    vid="method_payment_id"
                                    name="Cách thức thanh toán"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <div class="form-group">
                                        <el-checkbox-group
                                            v-model="method_payment_id"
                                            @change="handleChangeMethodPayment"
                                        >
                                            <div
                                                class="payment-option"
                                                v-for="item in methodPayment"
                                                :key="item.id"
                                                :label="item.id"
                                            >
                                                <div class="payment-checkbox">
                                                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                                                </div>

                                                <el-input
                                                    v-if="item.id === 3 && method_payment_id.includes(3)"
                                                    v-model="inputPaymentAmount"
                                                    placeholder="Nhập số tiền thanh toán"
                                                    class="payment-input"
                                                    type="text"
                                                />
                                            </div>
                                        </el-checkbox-group>

                                        <div v-if="method_payment_id.includes(4)" class="card-payment-panel">
                                            <div class="card-payment-content">
                                                <div class="card-payment-section-title">
                                                    Mục đích thanh toán <span class="text-danger">*</span>
                                                </div>

                                                <el-radio-group
                                                    v-model="cardPaymentPlan"
                                                    class="card-payment-plan-group"
                                                    @change="handleCardPaymentPlanChange"
                                                >
                                                    <el-radio
                                                        v-for="plan in visibleCardPaymentPlans"
                                                        :key="plan.value"
                                                        :label="plan.value"
                                                    >
                                                        {{ plan.label }}
                                                    </el-radio>
                                                </el-radio-group>

                                                <div v-if="isCardInstallmentPlan" class="d-flex align-items-center justify-content-between p-2 mb-3 bg-light rounded border">
                                                    <div>
                                                        <div class="font-weight-bold" style="font-size: 13px;">Trả góp qua Sacombank</div>
                                                        <small class="text-muted">Áp dụng chương trình liên kết ngân hàng Sacombank</small>
                                                    </div>
                                                    <el-switch
                                                        v-model="isSacombank"
                                                        active-color="#472f92"
                                                        @change="handleSacombankChange"
                                                    />
                                                </div>

                                                <div class="mb-3">
                                                    <div class="card-payment-section-title">
                                                        Số tiền khách hàng thanh toán <span class="text-danger">*</span>
                                                    </div>
                                                    <div v-if="quickAmounts.length" class="quick-amounts-group mb-2">
                                                        <button
                                                            v-for="preset in quickAmounts"
                                                            :key="'card-' + preset.key"
                                                            type="button"
                                                            class="quick-amount-pill"
                                                            :class="{ 'is-active': isAmountActive(cardPaymentAmountInput, preset.amount) }"
                                                            @click="setCardAmount(preset.amount)"
                                                        >
                                                            <span>{{ preset.name }}</span>
                                                            <span class="dot">·</span>
                                                            <span class="amount underline">
                                                                {{ formatPrice(preset.amount) }}
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <el-input
                                                        v-model="cardPaymentAmountInput"
                                                        placeholder="Nhập số tiền thanh toán"
                                                        class="card-amount-input"
                                                        type="text"
                                                    >
                                                        <template slot="suffix">
                                                            <span class="input-suffix-addon">đ</span>
                                                        </template>
                                                    </el-input>
                                                </div>

                                                <div class="card-payment-alert-box mb-3">
                                                    <i class="el-icon-warning-outline alert-icon"></i>
                                                    <span class="alert-text">{{ cardPaymentNotice }}</span>
                                                </div>

                                                <div class="card-payment-summary-grid mb-3">
                                                    <div class="summary-card fee-card">
                                                        <div class="summary-card-title">
                                                            Phí trả góp / phụ phí
                                                        </div>
                                                        <div class="summary-card-value">
                                                            {{ formattedCardInstallmentFee }} đ
                                                        </div>
                                                    </div>

                                                    <div class="summary-card total-card">
                                                        <div class="summary-card-title">
                                                            Tổng cần thanh toán
                                                        </div>
                                                        <div class="summary-card-value total-value">
                                                            {{ formattedCardTotalAmount }} đ
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="card-guide-block">
                                                    <div class="mt-1 text-left">
                                                        <h5 style="font-weight: 600; color: black" class="mb-3">
                                                            HƯỚNG DẪN THANH TOÁN ONEPAY
                                                        </h5>
                                                        <div style="line-height: 2; color: black">
                                                            <span style="color: black"><strong>Bước 1.</strong> Nhận link thanh toán Onepay trên phiếu đăng ký học tập</span><br/>
                                                            <span style="color: black">Kiểm tra nội dung hóa đơn và chọn "I agreed with Terms and Conditions", chọn CHECK OUT TO PAY để thực hiện thanh toán</span><br/>
                                                            <span style="color: black"><strong>Bước 2.</strong> Nhập thông tin thẻ</span><br/>
                                                            <span style="color: black">Khách hàng điền thông tin thẻ và nhấn nút Process Payment để thực hiện thanh toán</span><br/>
                                                            <span style="color: black"><strong>Lưu ý:</strong> Nếu thẻ có tham gia chương trình xác thực 3D-Secure thì sau khi nhập thông tin thẻ. Ngân hàng sẽ yêu cầu nhập thêm mật khẩu</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Hiển thị lỗi -->
                                        <div class="fv-plugins-message-container">
                                            <div class="fv-help-block">
                                                {{ errors[0] }}
                                            </div>
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="box-instruct" v-if="method_payment_id?.length">
                            <h5 style="font-weight: 600; color: black">Hướng dẫn thanh toán:</h5>
                            <div v-if="method_payment_id?.includes(3)" class="mb-4">
                                <div>
                                    <h5>- Thanh toán chuyển khoản</h5>
                                    <span
                                    >Bước 1: Chuyển khoản theo thông tin chi tiết {{ centerName }} cung
                    cấp
                  </span>
                                </div>

                                <div>
                  <span>Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền</span
                  ><br />
                                    <span
                                    >{{ centerName }} sẽ nhắn tin tới số điện thoại khách hàng cung cấp
                    trong nội dung chuyển khoản để xác nhận thông tin chuyển tiền muộn
                    nhất trong vòng 4h (theo giờ hành chính) sau khi nhận được tiền.
                    <span v-if="hotLine">Trường hợp không nhận được tin nhắn, bạn vui lòng báo khách hàng vui
                    lòng liên hệ qua {{ hotLine }} để được xử lý.</span>
                  </span><br />
                                    <span
                                    >{{ centerName }} không chịu trách nhiệm nếu trong quá trình chuyển
                    khoản sai thông tin. Trong một số tình huống cụ thể, khách hàng có thể
                    nhờ phía Ngân hàng thực hiện chuyển khoản hoặc Ngân hàng thụ hưởng của
                    {{ centerName }} để kiểm tra đối chứng cần thiết. Ngay khi nhận được
                    xác nhận từ Ngân hàng, {{ centerName }} sẽ tiến hành thủ tục tiếp theo
                    cho Khách hàng.</span
                                    ><br />
                                </div>
                            </div>

                            <div
                                class="mb-2"
                                style="line-height: 2"
                                v-if="[1, 2].some((id) => method_payment_id?.includes(id))"
                            >
                                <h5>- Thanh toán tiền mặt</h5>
                                <span>Nộp học phí trực tiếp tại hệ thống Trung tâm {{ centerName }}</span
                                ><br />
                                <span
                                >Thời gian: từ 14h00 đến 21h00 các ngày từ thứ 2 tới thứ 7 hàng tuần
                  (trừ ngày lễ, tết theo quy định Nhà nước).</span
                                >
                                <br />
                                <span
                                >Khi đến văn phòng giao dịch thuộc văn phòng {{ centerName }}, học viên
                  sẽ được nhân viên hướng dẫn các bước thanh toán.</span
                                >
                            </div>
                        </div>
                    </div>
                    <div>
                        <p class="font-weight-bold h2">Thông tin gửi QLHV chăm sóc khách hàng</p>
                        <div>
                            <div class="form-group">
                                <label class="form-label col-form-label"
                                >Thời gian học bị trùng lịch trong tuần<span class="text-danger"></span
                                ></label>
                                <el-input
                                    v-model="contract.overlap_time"
                                    filterable
                                    class="w-100"
                                    maxlength="50"
                                    placeholder="Các ngày cố định trong tuần hoặc khung giờ học cụ thể mà khách hàng đang bị vướng lịch"
                                ></el-input>
                            </div>
                            <div class="form-group">
                                <label class="form-label col-form-label"
                                >Khung giờ liên hệ phù hợp<span class="text-danger"></span
                                ></label>
                                <el-input
                                    v-model="contract.contact_time_frame"
                                    filterable
                                    maxlength="50"
                                    class="w-100"
                                    placeholder="Nhập khung giờ mà khách hành có thể nghe được điện thoại"
                                ></el-input>
                            </div>
                            <div class="form-group">
                                <label class="form-label col-form-label"
                                >Kênh liên hệ<span class="text-danger"></span
                                ></label>
                                <el-select
                                    filterable
                                    v-model="contract.contract_change"
                                    placeholder="Chọn trung tâm"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in methodContractChange"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <p v-if="contract.contract_change == 2 && !is_show" style="color: #ff8f00">Vui lòng nhập đúng tài khoản Zalo của khách hàng tại trường Số điện thoại khác.</p>
                            </div>
                            <div class="form-group">
                                <label class="form-label col-form-label"
                                >Nội dung khác<span class="text-danger"></span
                                ></label>

                                <el-input
                                    v-model="contract.other_content"
                                    filterable
                                    class="w-100"
                                    maxlength="200"
                                    placeholder="Nhập nội dung khác (hoàn cảnh, đề xuất đặc biệt)"
                                ></el-input>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <el-dialog
            id="gift"
            title="Chọn quà tặng"
            :visible.sync="giftDialogVisible"
            center
            style="right: 12px !important"
            append-to-body
        >
            <div class="list-code-container">
                <el-input
                    class="container mb-3"
                    placeholder="Nhập tên quà tặng"
                    @input="searchGift()"
                    v-model="dataSearchGift"
                />
                <div v-if="listGift.length > 0">
                    <div v-for="(item, index) in listGift" :key="'c' + index" :v-if="item.id">
                        <div
                            class="border border-info mb-3"
                            style="background-image: linear-gradient(to bottom, #dfeaff, #ffffff)"
                        >
                            <GiftDialog
                                :item="item"
                                :listPromotions="list_promotions_selected"
                                :giftSelect="gift_select"
                                @pickPrice="pickPromotions(item)"
                                @pickGift="pickGift(item)"
                                @showDetailPromotion="showDetailPromotion(item)"
                                @cancelGift="cancelGift(item)"
                            ></GiftDialog>
                        </div>
                    </div>
                </div>
                <div v-else class="no-promotion mt-2">
                    <p>Không có quà tặng</p>
                </div>
            </div>
        </el-dialog>

        <!-- Modal show combo   -->
        <el-dialog
            :title="titleDetail"
            :visible.sync="detailPromotionDialogVisible"
            width="40%"
            center
            style="right: 12px !important"
            append-to-body
        >
            <div class="row">
                <div class="col-xl-6 col-md-12">
                    <h1 style="font-size: 14px">Tên:</h1>
                    <el-input placeholder="Please input" :value="promotionDetail.nameCode">
                    </el-input>
                    <h1 style="font-size: 14px" class="mt-4">Ngày bắt đầu:</h1>
                    <el-input placeholder="Please input" :value="promotionDetail.startDate">
                    </el-input>
                </div>
                <div class="col-xl-6 col-md-12">
                    <h1 style="font-size: 14px">Giá trị:</h1>
                    <el-input
                        placeholder="Please input"
                        :value="`${promotionDetail.value}${
              promotionDetail.unit == MONEY ? 'VND' : '%'
            }`"
                    >
                    </el-input>
                    <h1 style="font-size: 14px" class="mt-4">Ngày kết thúc:</h1>
                    <el-input
                        placeholder="Please input"
                        :value="promotionDetail.endDate"
                        :disabled="true"
                    >
                    </el-input>
                </div>
                <div class="col-12">
                    <h1 style="font-size: 14px" class="mt-4">Mô tả voucher:</h1>
                    <el-input
                        type="textarea"
                        placeholder="Please input"
                        :value="promotionDetail.description"
                        :disabled="true"
                    >
                    </el-input>
                </div>
            </div>
        </el-dialog>
        <!-- End   -->
        <!-- Modal show voucher   -->
        <el-dialog
            id="voucher"
            title="Chọn voucher"
            :visible.sync="voucherDialogVisible"
            append-to-body
            width="70%"
        >
            <div class="list-code-container voucher-picker">
                <div class="row voucher-picker__search">
                    <div class="col-md-12 row">
                        <div class="col-md-12 row">
                            <label for="">Voucher</label>
                            <el-input
                                style="width: 100% !important;"
                                v-model="searchVoucher"
                                @input="searchVoucherByName()"
                                placeholder="Nhập mã voucher"
                            ></el-input>
                        </div>
                        <div class="col-md-6" v-if="customer?.student_deposit_log?.status == 2 && getNextMonthDayEight >= getNextNowMonthDayEight">
                            <label for="">Thời gian áp dụng voucher</label>
                            <el-date-picker
                                @change="searchVoucherByTime"
                                v-model="searchDate"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="Thời gian áp dụng voucher"
                                :picker-options="pickerStartOptions"
                            >
                            </el-date-picker>
						</div>
                    </div>
                </div>
                <div v-if="loadingVoucherGift">
                    <i class="el-icon-loading"></i>
                    loading...
                </div>
                <el-tabs v-else v-model="activeVoucherProgram" tab-position="left" class="voucher-program-tabs">
                    <el-tab-pane name="all">
                        <span slot="label">Tất cả ({{ totalVoucherCount }})</span>
                        <div class="voucher-picker__list">
                            <template v-for="program in voucherPrograms">
                            <section v-if="getVoucherList(program.id).length" :key="program.id" class="voucher-program-section">
                                <h3>{{ program.label }}</h3>
                                <VoucherDialog
                                    :arrayVoucher="arrayVoucher"
                                    :listCode="getVoucherList(program.id)"
                                    :colorCode="program.color"
                                    :allCode="allCode"
                                    :type="program.id"
                                    :customerSource="contract.nguon"
                                    :customerSchoolId="contract.co_quan"
                                    @openDetail="showDetailPromotion"
                                    @pickPromotions="morePickPromotions(program.id)"
                                    @updateSchoolLinkInfo="goToEditContractForSchoolLink"
                                />
                            </section>
                            </template>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane v-for="program in voucherPrograms" :key="program.id" :name="String(program.id)">
                        <span slot="label">{{ program.label }} ({{ getVoucherList(program.id).length }})</span>
                        <div class="voucher-picker__list">
                            <section class="voucher-program-section">
                                <h3>{{ program.label }}</h3>
                                <VoucherDialog
                                    :arrayVoucher="arrayVoucher"
                                    :listCode="getVoucherList(program.id)"
                                    :colorCode="program.color"
                                    :allCode="allCode"
                                    :type="program.id"
                                    :customerSource="contract.nguon"
                                    :customerSchoolId="contract.co_quan"
                                    @openDetail="showDetailPromotion"
                                    @pickPromotions="morePickPromotions(program.id)"
                                    @updateSchoolLinkInfo="goToEditContractForSchoolLink"
                                />
                            </section>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
        <CheckCicVideo :checkCicDialogVisible.sync="checkCicDialogVisible" />
        <el-dialog
            class="responsive"
            title="Thông báo tính năng mới"
            :visible.sync="dialogMessageFeatureNew"
        >
            <p>Phiếu đăng ký học tập nhãn Edutalk mới bổ sung thông tin quà tặng:</p>
            <img class="text-center" v-bind:src="'/media/images/contracts/feature-new.png'" />
            <p style="max-width: 950px; word-break: break-word" class="font-weight-bold mt-4">
                Hãy chắc chắn rằng bạn đã chọn đúng cả voucher và quà tặng cho khách hàng!
            </p>
            <p style="max-width: 950px; word-break: break-word">
                Thông tin voucher và quà tặng tại phiếu đăng ký học tập đều được gửi tới khách
                hàng xác nhận và là cơ sở để bộ phận vận hành trao quà cho học viên.
            </p>
            <p style="max-width: 950px; word-break: break-word">
                Vì vậy hãy đảm bảo bạn đã tư vấn & tạo phiếu đăng ký học tập đúng theo chương
                trình khuyến mại của tháng nhé!
            </p>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogMessageFeatureNew = false"
        >Đã hiểu</el-button
        >
      </span>
        </el-dialog>
        <!-- End   -->
        <!--    modal cảnh báo nhập SDT phụ huynh -->
        <el-dialog
            title="Thông báo"
            :visible.sync="checkDialogSDTPhuHuynh"
            class="responsive letter-spacing"
        >
            <p class="font-size">
                Hãy chắc chắn rằng bạn đã nhập đúng Số điện thoại Phụ huynh! <br /><br />

                Phụ huynh là người đại diện pháp lý có đủ năng lực hành vi dân sự để thực hiện
                giao dịch mua bán, có đầy đủ quyền và nghĩa vụ được quy định theo điều khoản dịch
                vụ này (bao gồm các điều khoản về chính sách và điều khoản dịch vụ, thanh toán,
                học tập, được chăm sóc và quyết định về thông tin bảo hành, bảo lưu, chuyển
                nhượng, ...) <br /><br />
                Nếu TVV nhập thông tin SĐT phụ huynh không đúng, bị phụ huynh hoặc bất kỳ bên thứ
                3 nào phản ánh dẫn đến tranh chấp hoặc phiếu đăng ký học tập bị vô hiệu, gây thiệt
                hại cho khách hàng và công ty thì TVV phải chịu hoàn toàn trách nhiệm trước pháp
                luật do việc nhập thông tin không đúng, và bồi thường toàn bộ thiệt hại gây ra, kể
                cả khi TVV đã nghỉ việc. <br /><br />
                Trung tâm sẽ tra cứu, nếu phát hiện vi phạm tiêu chuẩn "Nhập sai thông tin" tạo
                Phiếu đăng ký học tập, TVV sẽ cần chịu các trách nhiệm sau đây:<br />
                + Vi phạm lần 1: phạt 200.000 và lập biên bản <br />
                + Vi phạm lần 2: phạt 500.000 và lập biên bản <br />
                + Vi phạm lần 3: đề xuất tước quyền tư vấn viên
            </p>
            <div class="d-flex justify-content-center">
                <el-button class="bg-violet text-white" @click="checkDialogSDTPhuHuynh = false">
                    Đã hiểu
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="Phiếu đăng ký thay đổi tài khoản thanh toán"
            :visible.sync="checkedEditAccount"
        >
            <hr />
            <ChangeAccount
                :is_show="checkedEditAccount"
                @changeWaitingAccept="waitingAccept = true"
                :contract="contract"
                @close="checkedEditAccount = false"
            />
        </el-dialog>
    </ValidationObserver>
</template>

<script>
import { GET_CENTERS } from "@/core/services/store/center/center.module";
import { GET_BRANCHES } from "@/core/services/store/center/branch.module";
import { GET_COURSES } from "@/core/services/store/course/course.module";
import {
    LIST_VOUCHER,
} from "@/core/services/store/contract/contract.module";
import { CUSTOMER_FIND } from "@/core/services/store/customer/customer.module";
import {
    CONTRACT_ONLINE_GET_TUITION,
} from "@/core/services/store/contract/contractOnline.module";
import moment from "moment-timezone";
import { CENTER_EDUTALK, isWarrantyServiceCenter } from "@/core/config/center/centerOption";
import {
    DAI_HOC,
    EDUCATIONS,
    THCS,
    THPT,
} from "@/core/config/contract/contractOnlineOption";
import { GET_SCHOOL_ALL } from "@/core/services/store/contract/school.module";
import { GET_PROVINCES } from "@/core/services/store/public/provinces.module";
import { LIST_GIFT } from "@/core/services/store/contract/contract.module";
import { TYPE_GIFT, TYPE_VOUCHER } from "@/core/config/promotionOption";
import GiftDialog from "./GiftDialog";
import { CHECK_PARENT } from "@/core/services/store/user/users.module";
import { Code_Model } from "@/views/pages/customer/models/Code_Model";
import {
    FLASH_SALE,
    MONEY,
    OTHER_SCHOOL,
    PERCENT,
    PERIODIC_PROMOTIONS,
    SCHOOL_LINK,
} from "@/core/config/voucher_code/voucher_code";
import VoucherDialog from "@/views/pages/customer/components/VoucherDialog.vue";
import CheckCicVideo from "@/views/pages/customer/components/DialogCheckCicVideo";
import { DIGITAL } from "../../../../core/config/voucher_code/voucher_code";
import ChangeAccount from "./ChangeAccountPayment.vue";
import WarrantySelect from "./WarrantySelect.vue";
import {GET_DISTRICTS} from "@/core/services/store/public/districts.module";
import {GET_PARENT} from "@/core/services/store/customer/customer.module";


export default {
    name: "RegisterStudyForm",
    components: { VoucherDialog, GiftDialog, ChangeAccount, WarrantySelect, CheckCicVideo },
    props: {
        errorsForm: {
            type: Object,
            default: () => {
                return null;
            },
        },
        contract_prop: {
            type: Object,
            default: () => {
                return null;
            },
        },
        is_show: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
    },
    data() {
        return {
            count_unique: 0,
            combo_image: `${process.env.VUE_APP_BASE_URL}media/svg/combo.svg`,
            voucher_image: `${process.env.VUE_APP_BASE_URL}media/svg/voucher.svg`,
            total: 0,
            total_promotions: 0,
            total_course: 0,
            total_need: 0,
            promotionDetail: [],
            listPromotion: [],
            listVoucher: [],
            listGift: [],
            list_promotions_selected: [],
            giftDialogVisible: false,
            voucherDialogVisible: false,
            checkCicDialogVisible: false,
            detailPromotionDialogVisible: false,
            waitingAccept: false,
            searchVoucher: "",
            customer: null,
            dataSearchGift: null,
            listGiftSearch: [],
            method_payment_id: [],
            paymentOption: "",
            ratioPayment: '',
            inputPaymentAmount: "",
            cardPaymentPlan: "full",
            isSacombank: false,
            cardPaymentAmount: 0,
            cardPaymentAmountInput: "",
            isHydratingPayment: false,
            cardPaymentPlans: [
                { value: "full", label: "Trả thẳng", feeRate: 0.02 },
                { value: "installment_6", label: "Trả góp trong 6 tháng", feeRate: 0.025 },
                { value: "installment_9", label: "Trả góp trong 9 tháng", feeRate: 0.025 },
                { value: "installment_12", label: "Trả góp trong 12 tháng", feeRate: 0.025 },
            ],
            contract: {
                id: "",
                uuid: "",
                uuid_secret: "",
                is_confirm: 0,
                tuition_payment_id: "",
                is_older: true,
                name: "",
                phone: "",
                phone_other: "",
                payment_amount: "",
                installments_number: 0,
                email: "",
                birthday: "",
                center_id: "",
                branch_id: "",
                nguon: "",
                method_payment_id: "",
                is_sacombank: 0,
                installment_bank: null,
                installment_months: null,
                customer_id: this.$route.query.customer_id,
                total: "",
                address: '',
                cccd: '',
                co_quan: null,
                total_need: 0,
                total_paid: 0,
                destroy_fee: 0,
                total_promotions: 0,
                service_id: null,
                service: null,
                service_total: 0,
                courses: [
                    {
                        id: "",
                        name: "",
                        fee: 0,
                    },
                ],
                student_register_courses: [
                    {
                        course: {},
                        fee: "",
                    },
                ],
                list_promotions: [],
                gift_id: [],
                parent: {
                    type: "bo",
                    other_value: "",
                    name: "",
                    phone: "",
                    phone_other: "",
                },
            },
            gift_select: [],
            courses: [],
            centers: [],
            branches: [],
            tuitions: [],
            methodPayment: [
                { id: 1, name: "Tiền mặt" },
                { id: 2, name: "Quẹt thẻ máy POS" },
                { id: 3, name: "Chuyển khoản" },
                { id: 4, name: "Thanh toán qua thẻ" },
            ],
            type: [],
            TYPE_VOUCHER: TYPE_VOUCHER,
            TYPE_GIFT: TYPE_GIFT,
            dialogMessageFeatureNew: false,
            schools: [],
            provinces: [],
            checkDialogSDTPhuHuynh: false,
            educations: EDUCATIONS,
            loadingBranches: false,
            loadingCourses: false,
            loadingVoucherGift: false,
            PERCENT: PERCENT,
            MONEY: MONEY,
            SCHOOL_LINK: SCHOOL_LINK,
            FLASH_SALE: FLASH_SALE,
            PERIODIC_PROMOTIONS: PERIODIC_PROMOTIONS,
            OTHER_SCHOOL: OTHER_SCHOOL,
            DIGITAL: DIGITAL,
            activeVoucherProgram: "all",
            allCode: {},
            numberCode: 0,
            listCodeSearch: {},
            arrayVoucher: [],
            digitalBranch: 182,
            checkedEditAccount: false,
            qrCode: "",
            prefix: "",
            hotLine: "",
            centerName: "",
            districts: {},
            methodContractChange: [
                { id: 1, name: "Điện thoại" },
                { id: 2, name: "Zalo" },
            ],
            searchDate: '',
            pickerStartOptions: {
                disabledDate: this.disabledStartDate
            },
        };
    },

    watch: {
        inputPaymentAmount(val) {
            const raw = val.replace(/\D/g, "");
            const numericValue = parseInt(raw) || 0;
            if(numericValue > this.finalTotalNeed) {
                this.inputPaymentAmount = 0;
                this.$message.error(
                    "Số tiền nạp đã vượt quá số tiền cần đóng"
                );
                return;
            }
            this.contract.payment_amount = numericValue;
            this.inputPaymentAmount = numericValue.toLocaleString("vi-VN");

        },
        "contract.payment_amount": {
            immediate: true,
            handler(val) {
                this.inputPaymentAmount = val ? val.toLocaleString("vi-VN") : "";
            },
        },
        cardPaymentAmountInput(val) {
            const raw = `${val || ""}`.replace(/\D/g, "");
            const numericValue = parseInt(raw) || 0;
            if (
                !this.isHydratingPayment &&
                this.finalTotalNeed > 0 &&
                numericValue > this.finalTotalNeed
            ) {
                this.cardPaymentAmount = 0;
                this.cardPaymentAmountInput = "0";
                this.$message.error("Số tiền nạp đã vượt quá số tiền cần đóng");
                return;
            }
            this.cardPaymentAmount = numericValue;
            this.cardPaymentAmountInput = numericValue
                ? numericValue.toLocaleString("vi-VN")
                : "";
            this.syncPaymentAmountByMethod();
        },
        contract: {
            handler(newVal, oldVal) {
                this.contract.list_promotions = this.list_promotions_selected;
                this.contract.total = this.total;
                if (this.contract?.gifts) {
                    this.gift_select = this.contract?.gifts;
                }
                this.$emit("dataContract", this.contract);
            },
            deep: true,
            immediate: true,
        },
        contract_prop: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (!newVal) return;

                this.contract = newVal;
                this.list_promotions_selected = newVal.list_promotions || [];

                this.applyDefaultWarrantyService();
                this.calcPrice();

                await this.loadContractDependencies();
                const contractIdChanged = !oldVal || newVal?.id !== oldVal?.id;
                const paymentOptionChanged =
                    (newVal?.payment_options?.id || null) !== (oldVal?.payment_options?.id || null) ||
                    (newVal?.payment_options?.updated_at || null) !== (oldVal?.payment_options?.updated_at || null) ||
                    (newVal?.payment_options?.payment_method || null) !== (oldVal?.payment_options?.payment_method || null);
                if (contractIdChanged || paymentOptionChanged) {
                    this.hydratePaymentFromContract();
                } else if (Array.isArray(this.contract?.method_payment_id)) {
                    this.method_payment_id = this.contract.method_payment_id.map((id) => Number(id));
                } else {
                    this.hydratePaymentFromContract();
                }
                const branchChanged = newVal?.branch_id !== oldVal?.branch_id;
                const centerChanged = newVal?.center_id !== oldVal?.center_id;
                const tuitionChanged = newVal?.tuition_payment_id !== oldVal?.tuition_payment_id;
                if (
                    this.contract?.branch_id &&
                    this.contract?.center_id &&
                    (!oldVal || branchChanged || centerChanged || tuitionChanged)
                ) {
                    this.openListVoucher();
                }
            },
        },
        errorsForm: {
            handler() {
                if (_.size(this.errorsForm)) {
                    this.$refs.form.setErrors(this.errorsForm);
                }
            },
            deep: true,
            immediate: true,
        },
    },
    async mounted() {
        this.dialogMessageFeatureNew = false;
        this.type = [];
        this.getParentByCustomer();

        await this.getCenter();
        await this.getCustomer();

        await this.handleBirthday();
        this.getTuition();
        this.getProvince();
        await this.getSchool();
        await this.getDistricts();
    },
    methods: {
        async loadContractDependencies() {
            const { center_id, branch_id } = this.contract;

            if (!center_id) return;

            this.loadingBranches = true;

            try {
                await this.getBranch();
            } finally {
                this.loadingBranches = false;
            }

            if (!branch_id) return;

            this.loadingCourses = true;

            try {
                await Promise.all([
                    this.getCourse(),
                    this.openListVoucher(),
                ]);
            } finally {
                this.loadingCourses = false;
            }
        },
        disabledStartDate(date) {
            const timeline = this.customer?.student_deposit_log?.timeline;

            if (timeline) {
                const timelineDate = new Date(timeline);
                timelineDate.setHours(0, 0, 0, 0);

                const currentDate = new Date(date);
                currentDate.setHours(0, 0, 0, 0);

                return currentDate < timelineDate;
            }

            return date > new Date();
        },
        applyDefaultWarrantyService() {
            if (!this.contract.id && !this.contract.service_id) {
                if (isWarrantyServiceCenter(this.contract.center_id)) {
                    this.$set(this.contract, "service_id", 2);
                } else {
                    this.$set(this.contract, "service_id", null);
                }
            }
        },
        resetWarrantyService() {
            this.$set(this.contract, "service_id", null);
            this.$set(this.contract, "service", null);
            this.$set(this.contract, "service_total", 0);
        },
        isWarrantyServiceCenter,
        setSelectedWarrantyService(service) {
            const percent = Number(
                service && service.percent_price != null ? service.percent_price : service?.percent
            ) || 0;
            const total = Number(this.total) || Number(this.contract.total) || 0;

            this.contract.service_id = service ? service.id : null;
            this.$set(this.contract, "service", service || null);
            this.$set(this.contract, "service_total", service ? (total * percent) / 100 : 0);
            this.calcPrice();
        },
        getParentByCustomer() {
            let customer_id = this.$route.query.customer_id;
            return this.$store.dispatch(GET_PARENT, {customer_id:customer_id}).then((res) => {
                let data = res.data;
                this.contract.parent = {
                    type: data.parent?.type ?? 'bo',
                    name: data.parent?.name ?? '',
                    phone: data.parent?.phone ?? '',
                    phone_other: data.phone_other ?? '',
                };

            });
        },
        handleEducation() {
            this.contract.school_id = "";
            this.getSchool();
        },
        getProvince() {
            return this.$store.dispatch(GET_PROVINCES).then((data) => {
                this.provinces = data.data;
            });
        },
        async getSchool() {
            if (!this.contract.education_id || !this.contract.province_id) {
                return false;
            }
            await this.$store
                .dispatch(GET_SCHOOL_ALL, {
                    education_id: this.contract.education_id,
                    province_id: this.contract.province_id,
                })
                .then((data) => {
                    this.schools = data.data;
                });
        },
        searchGift() {
            this.listGift = this.listGiftSearch.filter((gift) => {
                return gift.name.toUpperCase().includes(this.dataSearchGift.toUpperCase());
            });
        },
        getQuantityCourse() {
            return (this.total_course = this.contract.courses.filter((item) => {
                return item.id > 0;
            }).length);
        },
        checkUniquePhone() {
            if (this.contract.phone && this.contract.phone !== this.contract.parent.phone) {
                this.$store
                    .dispatch(CHECK_PARENT, { phone: this.contract.parent.phone })
                    .then((data) => {
                        if (data.data) {
                            this.$message.error(
                                "Số điện thoại của phụ huynh không được trùng với số điện thoại của nhân sự công ty. Vui lòng nhập lại đúng thông tin phụ huynh."
                            );
                        }
                    });
            }
        },
        getTuition() {
            this.$store.dispatch(CONTRACT_ONLINE_GET_TUITION).then((data) => {
                this.tuitions = data.data;
            });
        },
        async getCenter() {
            await this.$store
                .dispatch(GET_CENTERS, {
                    limit: 10000,
                    is_edutalk: CENTER_EDUTALK,
                    status: 1,
                })
                .then((data) => {
                    this.centers = data.data.data;
                });
        },
        async getBranch() {
            await this.$store
                .dispatch(GET_BRANCHES, {
                    limit: 10000,
                    center_id: this.contract.center_id,
                    type: this.type,
                    noibo: true,
                })
                .then((data) => {
                    this.branches = data.data;
                });
        },
        async getCourse() {
            await this.$store
                .dispatch(GET_COURSES, {
                    per_page: 10000,
                    center_id: this.contract.center_id,
                    branch_id: this.contract.branch_id,
                    status: 1,
                    show_internal_web:1
                })
                .then((data) => {
                    this.courses = data.data.data;
                });
        },
        async getCustomer() {
            let id = this.$route.query.customer_id
                ? parseInt(this.$route.query.customer_id)
                : "";
            await this.$store.dispatch(CUSTOMER_FIND, id).then((data) => {
                this.customer = data.data;
                this.contract.name = this.customer.name;
                this.contract.phone = this.customer.phone;
                this.contract.email = this.customer.email;
                this.contract.address = this.customer.address
                this.contract.cccd = this.customer.cccd
                this.contract.birthday =  this.customer.ngay_sinh == "0000-00-00" || !this.customer.ngay_sinh
                    ? ""
                    : this.customer.ngay_sinh;
                this.contract.branch = this.customer?.user_intro_branch_id;
                this.contract.user_id = this.customer?.user?.id;
                this.$set(this.contract, "nguon", this.customer?.nguon ?? "");
                this.$set(this.contract, "co_quan", data.data?.co_quan ?? null);
                this.searchDate = this.customer?.student_deposit_log?.timeline;
            });
        },
        async validateForm() {
            const valid = await this.$refs.form.validate();
            return {
                valid,
                values: { ...this.contract }
            }
        },
        summit() {},
        addNewCourse: function () {
            this.contract.courses.push({
                id: "",
                name: "",
                fee: "",
            });
            this.contract.student_register_courses.push({
                course: {},
                fee: "",
            });
        },
        setCourseDefault() {
            return [
                {
                    id: "",
                    name: "",
                    fee: "",
                },
            ];
        },
        setRegisterCourseDefault() {
            return [
                {
                    course: {},
                    fee: "",
                },
            ];
        },
        removeCourse(index) {
            this.resetGift();
            this.list_promotions_selected = [];
            this.checkVoucherSelected();
            this.contract.courses.splice(index, 1);
            this.contract.student_register_courses.splice(index, 1);
            this.calcPrice();
        },
        async handleCourse(event) {
            this.list_promotions_selected = [];
            this.resetGift();
            this.resetVoucher();
            this.checkVoucherSelected();
            this.addValue(event);
            this.calcPrice();
            this.$forceUpdate();

            await this.openListVoucher();
        },
        async handleCenter() {
            this.loadingBranches = true;
            this.loadingCourses = false;

            this.type = [2, 3];
            this.list_promotions_selected = [];
            this.branches = [];
            this.courses = [];
            this.listVoucher = [];
            this.listGift = [];
            this.allCode = {};

            this.contract.branch_id = "";
            this.contract.courses = this.setCourseDefault();
            this.contract.student_register_courses = this.setRegisterCourseDefault();

            if (!isWarrantyServiceCenter(this.contract.center_id)) {
                this.resetWarrantyService();
            }

            this.applyDefaultWarrantyService();
            this.method_payment_id = [];
            this.paymentOption = "";
            this.resetCardPaymentState();

            try {
                if (!this.contract.center_id) {
                    return;
                }

                // Bước chọn trung tâm chỉ tải danh sách chi nhánh.
                // Không gọi khóa học/voucher khi branch_id đang rỗng.
                await this.getBranch();
            } catch (error) {
                this.branches = [];
                this.$message.error("Không thể tải danh sách chi nhánh");
            } finally {
                this.loadingBranches = false;
            }
            this.resetCardPaymentState();
        },
        async handleBranch() {
            this.loadingCourses = true;

            this.courses = [];
            this.listVoucher = [];
            this.listGift = [];
            this.allCode = {};

            this.contract.courses = this.setCourseDefault();
            this.contract.student_register_courses = this.setRegisterCourseDefault();
            this.list_promotions_selected = [];

            this.resetGift();
            this.cancelGift({});

            try {
                if (!this.contract.branch_id) {
                    return;
                }

                // Chỉ mở khóa học khi khóa học, voucher và quà đã tải xong.
                await Promise.all([
                    this.getCourse(),
                    this.openListVoucher(),
                ]);
            } catch (error) {
                this.courses = [];
                this.$message.error("Không thể tải dữ liệu theo chi nhánh");
            } finally {
                this.loadingCourses = false;
            }
        },
        async handleTuitionPayment() {
            this.resetGift();
            this.resetVoucher();
            await this.openListVoucher();
            if (Number(this.contract.tuition_payment_id) !== 2 && this.isCardInstallmentPlan) {
                this.cardPaymentPlan = "full";
                this.handleCardPaymentPlanChange();
            }
        },
        getVoucherList(programId) {
            const vouchers = this.searchVoucher
                ? this.listCodeSearch[programId]
                : this.allCode[programId];

            return Array.isArray(vouchers) ? vouchers : [];
        },
        searchVoucherByName() {
            this.voucherPrograms.forEach(({ id }) => {
                const vouchers = Array.isArray(this.allCode[id]) ? this.allCode[id] : [];
                this.$set(this.listCodeSearch, id, vouchers.filter((code) =>
                    (code.nameCode || code.name || "").toLowerCase().includes(this.searchVoucher.toLowerCase())
                ));
            });
        },
        calcPrice() {
            this.total = 0;
            let total_normal = 0;
            let courses = this.contract.courses;
            let register_courses = this.contract.student_register_courses;
            let courses_flash_sale = [];
            // tìm trong promotion course flash sale
            for (let i = 0; i < this.list_promotions_selected.length; i++) {
                if (
                    this.list_promotions_selected[i].is_flash_sale == 1 &&
                    this.list_promotions_selected[i].course.id
                ) {
                    courses_flash_sale.push(this.list_promotions_selected[i].course.id);
                }
            }
            for (let i = 0; i < register_courses.length; i++) {
                this.total = this.total + register_courses[i].fee;
                if (!courses_flash_sale.includes(register_courses[i].course.id)) {
                    total_normal = total_normal + register_courses[i].fee;
                }
            }

            // Cacl promotion
            let value_promotions_total = 0;
            this.list_promotions_selected.map((promo) => {
                const targetCourseId =
                    promo.course_discount ||
                    promo.courseDiscount ||
                    (promo.pivot && (promo.pivot.course_discount || promo.pivot.courseDiscount)) ||
                    (promo.course && promo.course.id) ||
                    null;
                const matchedRegCourse = targetCourseId
                    ? (register_courses || []).find(
                        (c) => +c.course_id === +targetCourseId || (c.course && +c.course.id === +targetCourseId)
                    )
                    : null;
                const matchedCourse = targetCourseId
                    ? (courses || []).find(
                        (c) => +c.id === +targetCourseId || +c.course_id === +targetCourseId
                    )
                    : null;
                const feeOfTargetCourse = Number(
                    matchedRegCourse?.fee ?? matchedRegCourse?.course_fee ?? matchedCourse?.fee ?? matchedCourse?.course_fee ?? 0
                );

                if (promo.unit == 1) {
                    // tiền mặt
                    if (targetCourseId) {
                        if (feeOfTargetCourse > 0) {
                            value_promotions_total += Number(promo.value) || 0;
                        }
                    } else {
                        value_promotions_total += Number(promo.value) || 0;
                    }
                    promo.value = promo.value;
                } else {
                    // phần trăm
                    if (promo.program_id === FLASH_SALE && promo.course_ids) {
                        let feeOfCourse = (courses || []).find((course) => +course.id === +promo.course_ids)?.fee ?? 0;
                        value_promotions_total += (feeOfCourse * promo.value) / 100;
                    } else if (promo.is_flash_sale == 1) {
                        // flash sale
                        let feeOfCourse = feeOfTargetCourse > 0 ? feeOfTargetCourse : Number(this.contract.total) || 0;
                        value_promotions_total += (feeOfCourse * promo.value) / 100;
                    } else if (targetCourseId) {
                        // Khuyến mại theo khóa cụ thể
                        if (feeOfTargetCourse > 0) {
                            value_promotions_total += (feeOfTargetCourse * promo.value) / 100;
                        }
                    } else {
                        value_promotions_total += (total_normal * promo.value) / 100;
                    }
                }
            });
            if (this.contract.service) {
                const percent = Number(
                    this.contract.service.percent_price != null
                        ? this.contract.service.percent_price
                        : this.contract.service.percent
                ) || 0;

                this.$set(this.contract, "service_total", (this.total * percent) / 100);
            }

            this.total_promotions = value_promotions_total;
            let baseTotalNeed = 0;
            if (this.contract.total_paid > 0) {

                let destroy_fee = this.contract.destroy_fee ?? 0;
                this.contract.total_promotions = this.total - (this.contract.total_after_voucher - destroy_fee) + this.contract.service_total;
                baseTotalNeed = this.contract.total_after_voucher;
            } else {
                this.contract.total_promotions = value_promotions_total;
                baseTotalNeed = this.total - value_promotions_total + this.contract.service_total;
                this.contract.total_after_voucher = baseTotalNeed;
            }

            const shouldSubtractDeposit = this.customer?.student_deposit_log?.status == 2;
            const depositValue = shouldSubtractDeposit ? Number(this.customer?.total_deposit_log) || 0 : 0;
            const finalTotalNeed = Math.max(Number(baseTotalNeed) - depositValue, 0);

            this.total_need = finalTotalNeed;
            this.contract.total_need = finalTotalNeed;
        },
        addValue(event) {
            this.courses.map((course) => {
                this.contract.courses.map((item, index) => {
                    if (course.id == item.id) {
                        this.contract.courses[index].name = course.name;
                        this.contract.courses[index].fee = course.fee;
                        this.contract.courses[index].id = course.id;
                        this.contract.courses[index].promotion_flash_sale =
                            course.promotion_flash_sale;
                    }
                });
            });
            let found = this.contract.courses.findIndex((element) => element.id == event.id);
            this.contract.student_register_courses[found].fee = event.fee;
            this.contract.student_register_courses[found].course = event;
            this.checkUniqueCourse(event);
        },
        checkUniqueCourse(event) {
            let courses = this.contract.courses;
            let count_unique = 0;
            let index = 0;
            for (let i = 0; i <= courses.length; i++) {
                let item = courses[i];
                if (item && item.id) {
                    if (item.id === event.id) {
                        index = i;
                        count_unique++;
                    }
                }
            }
            if (count_unique > 1) {
                this.contract.courses.splice(index, 1);
                this.contract.student_register_courses.splice(index, 1);
                this.$message.error("Khóa học đã được chọn");
                return false;
            }
        },
        openListGift() {
            this.giftDialogVisible = true;
        },
        viewVoucher() {
            this.activeVoucherProgram = "all";
            this.voucherDialogVisible = true;
            this.openListVoucher();
        },
        goToEditContractForSchoolLink() {
            const customerId = this.$route.query.customer_id;
            if (!customerId) {
                this.$message.error("Không tìm thấy hợp đồng cần cập nhật");
                return;
            }

            this.voucherDialogVisible = false;
            this.$router.push({
                name: "customer-edit",
                params: { id: customerId },
            });
        },
        async openListVoucher() {
            this.loadingVoucherGift = true;
            this.searchVoucher = "";

            const courseSend = this.contract.courses
                .map((course) => course.id)
                .filter(Boolean);

            try {
                const response = await this.$store.dispatch(LIST_VOUCHER, {
                    name: this.searchVoucher,
                    branch_id: this.contract.branch_id,
                    center_id: this.contract.center_id,
                    course_ids: courseSend,
                    tuition_payment_id: this.contract.tuition_payment_id,
                    quantity_course: this.getQuantityCourse(),
                    start_date: this.searchDate,
                });

                this.listVoucher = response.data || [];
                await this.getListGift();
                    this.checkVoucherSelected();
                    this.syncCardPaymentToContract();
                }finally {
                this.loadingVoucherGift = false;
            }
        },
        async getListGift() {
            let courseSend = [];
            _.each(this.contract.courses, function (course) {
                courseSend.push(course.id);
            });

            this.listGift = [];
            if (!this.contract.branch_id) {
                this.listGiftSearch = [];
                this.allCode = {};
                return;
            }

            return this.$store
                .dispatch(LIST_GIFT, {
                    branch_id: this.contract.branch_id,
                    quantity_course: this.getQuantityCourse(),
                    tuition_payment_id: this.contract.tuition_payment_id,
                    course_ids: courseSend,
                    start_date: this.searchDate
                })
                .then((response) => {
                    this.listGift = response.data;
                    let giftModel = this.listGift.map((voucher) => {
                        return new Code_Model(
                            voucher.program_id,
                            voucher?.branch_id,
                            voucher?.course,
                            voucher?.course_ids,
                            voucher?.gift,
                            voucher?.id,
                            voucher?.is_center,
                            voucher?.type,
                            voucher?.value,
                            voucher?.name,
                            0,
                            voucher?.start_date,
                            voucher?.end_date,
                            voucher?.description,
                            voucher.unit,
                            voucher.value,
                            true,
                            true,
                            voucher.payment_deadline,
                            voucher.payment_value,
                            voucher
                        );
                    });
                    let voucherModel = this.listVoucher?.map((voucher) => {
                        return new Code_Model(
                            voucher.program_id,
                            voucher?.branch_id,
                            voucher?.course,
                            voucher?.course_ids,
                            voucher?.gift,
                            voucher?.id,
                            voucher?.is_center,
                            voucher?.type,
                            voucher?.value,
                            voucher?.name,
                            +voucher?.is_flash_sale,
                            voucher?.start_date,
                            voucher?.end_date,
                            voucher?.description,
                            voucher.unit,
                            voucher.amount,
                            null,
                            null,
                            null,
                            null,
                            voucher?.truong_hoc,
                            voucher?.installment_fee_payer,
                            voucher?.installment_fee,
                            voucher?.discount_method,
                            voucher?.course_discount
                        );
                    });
                        let ListProgramUsed =
                            this.list_promotions_selected.length === 0
                                ? []
                                : this.list_promotions_selected.map((promotion) => promotion.program_id);
                        let code = voucherModel.concat(giftModel).map((voucher) => {
                            if (
                                this.list_promotions_selected.find((e) => e.id == voucher.id) ||
                                this.contract.gift_id.find((b) => b == voucher.id)
                            ) {
                                return { ...voucher, selected: true };
                            }
                            return ListProgramUsed.length === 0
                                ? voucher
                                : ListProgramUsed.includes(voucher.program_id)
                                    ? voucher.program_id == SCHOOL_LINK
                                        ? { ...voucher, hidden: true }
                                        : voucher
                                    : { ...voucher, hidden: true };
                        });

                    this.allCode = _.groupBy(code, ({ program_id }) => program_id);
                    this.listGiftSearch = [...this.listGift];
                    // this.setGiftSelect(this.listGift);
                });
        },
        normalizeIds(value) {
            if (Array.isArray(value)) {
                return value
                    .map(item => (item && typeof item === "object" ? item.id : item))
                    .filter(item => item !== null && item !== undefined && item !== "")
                    .map(item => String(item));
            }

            if (value && typeof value === "object") {
                return this.normalizeIds(value.id);
            }

            if (typeof value === "string" && value.includes(",")) {
                return value.split(",").map(item => item.trim()).filter(Boolean);
            }

            if (value === null || value === undefined || value === "") {
                return [];
            }

            return [String(value)];
        },
        getVoucherAffiliatedSchoolIds(voucher) {
            return this.normalizeIds(voucher.affiliated_school_id);
        },
        normalizeText(value) {
            return String(value || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .trim();
        },
        isSchoolLinkSource(value) {
            return this.normalizeText(value) === "lien ket truong";
        },
        applySchoolLinkVoucherRule(voucher) {
            if (+voucher.program_id !== SCHOOL_LINK) {
                return voucher;
            }

            const affiliatedSchoolIds = this.getVoucherAffiliatedSchoolIds(voucher);
            const customerSchoolId = this.contract.co_quan ? String(this.contract.co_quan) : "";
            const validSource = this.isSchoolLinkSource(this.contract.nguon);
            const validSchool = Boolean(customerSchoolId) && affiliatedSchoolIds.includes(customerSchoolId);

            if (validSource && validSchool) {
                return {
                    ...voucher,
                    disabled: false,
                    disabled_reason: ""
                };
            }

            return {
                ...voucher,
                disabled: true,
                selected: false,
                disabled_reason: "Tr\u01b0\u1eddng h\u1ecdc ho\u1eb7c k\u00eanh kh\u00e1ch h\u00e0ng kh\u00f4ng h\u1ee3p l\u1ec7."
            };
        },
        removeDisabledSchoolLinkSelected(code) {
            const disabledIds = code
                .filter(item => +item.program_id === SCHOOL_LINK && item.disabled)
                .map(item => String(item.id));

            if (!disabledIds.length) {
                return;
            }

            this.list_promotions_selected = this.list_promotions_selected.filter(
                item => !disabledIds.includes(String(item.id))
            );
            const giftIds = Array.isArray(this.contract.gift_id) ? this.contract.gift_id : [];
            this.contract.gift_id = giftIds.filter(
                item => !disabledIds.includes(String(item))
            );
        },
        goToCustomerEdit() {
            const customerId = this.contract.customer_id || this.$route.query.customer_id;
            if (!customerId) {
                return;
            }

            this.$router.push({
                name: "customer-edit",
                params: { id: customerId }
            });
        },
        showDetailPromotion(item) {
            this.promotionDetail = item;
            this.detailPromotionDialogVisible = true;
            // this.$store.dispatch(FIND_PROMOTION, item.id).then((response) => {
            // 	this.promotionDetail = response.data;
            // });
        },
        pickPromotions(event) {
            this.dataSearchGift = "";
            if (!event.amount && event.amount != null) {
                this.$message.error("Voucher bạn chọn đã hết lượt sử dụng");
                return;
            }
            this.giftDialogVisible = false;

            this.promotion_id = event.id;
            let temp = this.list_promotions_selected;
            _.each(temp, function (value, key) {
                if (event.type === 1 || event.type === 2) {
                    if (value.type === 1 || value.type === 2) {
                        temp.splice(key, 1);
                    }
                }
            });
            temp.push(event);
            this.list_promotions_selected = temp;

            this.calcPrice();
            if (event.type === TYPE_VOUCHER) {
                this.checkVoucherSelected();
            }
            this.arrayVoucher.push(event.id);
            this.syncCardPaymentToContract();
        },
        morePickPromotions(key) {
            this.list_promotions_selected = [];
            this.contract.gift_id = [];
            this.gift_select = [];
            this.allCode[key]
                .filter((code) => code.selected === true)
                .forEach((item) => {
                    item.isUseGift ? this.pickGift(item) : this.pickPromotions(item);
                });
        },
        pickGift(event) {
            this.dataSearchGift = "";
            this.contract.gift_id.push(event.id);
            this.gift_select = event;
            this.unPickPromotions(event);
        },
        cancelGift(item) {
            this.dataSearchGift = "";
            this.contract.description = "";
            this.contract.gifts = [];
            this.resetGift();
            this.unPickPromotions(item);
        },
        resetGift() {
            this.contract.gift_id = [];
            this.gift_select = [];
        },
        resetVoucher() {
            this.list_promotions_selected = [];
            this.contract.list_promotions = [];
        },
        unPickPromotions(data) {
            this.list_promotions_selected = this.list_promotions_selected.filter(
                (item) => item.id !== data.id
            );
            this.checkVoucherSelected();
            this.calcPrice();
            this.syncCardPaymentToContract();
        },
        checkVoucherSelected() {
            let temp = this.list_promotions_selected;
            let arr_FS = [];
            temp.map(function (item) {
                if (item.is_flash_sale == 1 && item.course) {
                    arr_FS.push(item.course.id);
                }
            });

            this.listVoucher.map(function (item) {
                if (item.is_flash_sale == 1 && arr_FS.length > 0) {
                    item.is_selected_FS = 1;
                } else {
                    item.is_selected_FS = 0;
                }
                let index_selected = temp.findIndex((e) => e.id === item.id);
                if (index_selected >= 0) {
                    item.is_selected = 1;
                } else {
                    item.is_selected = 0;
                }
            });
        },
        handleBirthday() {
            if (!this.contract.birthday) {
                this.contract.is_older = true;
                return 1;
            }
            let age = moment().diff(this.contract.birthday, "years", true);
            if (age >= 15) {
                this.contract.is_older = true;
            } else {
                this.contract.is_older = false;
            }
        },
        setGiftSelect(listGift) {
            let gift_id = this.contract?.gift_id[0];
            for (let i = 0; i < listGift.length; i++) {
                if (listGift[i].id === gift_id) {
                    this.gift_select = listGift[i];
                }
            }
        },

        async handleChangeMethodPayment() {
            if (!this.contract.branch_id) {
                this.method_payment_id = [];
                this.contract.payment_amount = "";
                this.resetCardPaymentState();
                this.$notify({
                    title: "Vui lòng chọn chi nhánh học tập!",
                    message: "Thiếu dữ liệu",
                    type: "warning",
                });
                return;
            }
            this.prefix = this.contract.center_id === 295 ? "EC" : "IE";
            this.centerName = this.prefix == "EC" ? "ECoach" : "IELTS Mentor";

            switch (this.contract.center_id) {
                case 295:
                    this.hotLine = 'tổng đài 1900 4782';
                    break;

                case 530:
                case 516:
                    this.hotLine = 'tổng đài 1900 4455';
                    break;

                default:
                    this.hotLine = '';
                    break;
            }

            const methodNames = this.methodPayment
                .filter((item) => this.method_payment_id.includes(item.id))
                .map((item) => item.name);
            this.contract.method_payment_id = this.method_payment_id;
            if (!this.method_payment_id.includes(4)) {
                this.resetCardPaymentState();
            }
            if (!this.method_payment_id.includes(3) && !this.method_payment_id.includes(4)) {
                this.contract.payment_amount = "";
                this.inputPaymentAmount = "";
            }
            this.syncCardPaymentToContract(methodNames);
        },
        getCardInstallmentMonths() {
            if (this.cardPaymentPlan === "installment_6") return 6;
            if (this.cardPaymentPlan === "installment_9") return 9;
            if (this.cardPaymentPlan === "installment_12") return 12;
            return null;
        },
        handleCardPaymentPlanChange() {
            if (this.cardPaymentPlan === "full") {
                this.isSacombank = false;
                this.contract.is_sacombank = 0;
                this.contract.installment_bank = null;
                this.contract.installment_months = null;
            } else if (this.isSacombank) {
                this.contract.installment_months = this.getCardInstallmentMonths();
            }
            const methodNames = this.methodPayment
                .filter((item) => this.method_payment_id.includes(item.id))
                .map((item) => item.name);
            this.syncCardPaymentToContract(methodNames);
        },
        handleSacombankChange(value) {
            if (typeof value === "boolean") {
                this.isSacombank = value;
            }
            this.contract.is_sacombank = this.isSacombank ? 1 : 0;
            if (this.isSacombank) {
                this.contract.installment_bank = "sacombank";
                this.contract.installment_months = this.getCardInstallmentMonths();
            } else {
                this.contract.installment_bank = null;
                this.contract.installment_months = null;
            }
            const methodNames = this.methodPayment
                .filter((item) => this.method_payment_id.includes(item.id))
                .map((item) => item.name);
            this.syncCardPaymentToContract(methodNames);
        },
        normalizeMethodPaymentIds(raw) {
            if (Array.isArray(raw)) {
                return raw
                    .map((id) => Number(id))
                    .filter((id) => !Number.isNaN(id) && id > 0);
            }
            if (raw == null || raw === "") {
                return [];
            }
            return String(raw)
                .split(",")
                .map((id) => Number(id))
                .filter((id) => !Number.isNaN(id) && id > 0);
        },
        parseMethodPaymentIdsFromLabel(label) {
            if (!label) {
                return [];
            }
            const ids = this.methodPayment
                .filter((item) => label.includes(item.name))
                .map((item) => item.id);
            if (
                !ids.includes(2) &&
                label.includes("Quẹt thẻ") &&
                !label.includes("Thanh toán qua thẻ")
            ) {
                ids.push(2);
            }
            return ids;
        },
        parseCardPaymentPlanFromLabel(label) {
            if (!label) {
                return "full";
            }
            if (label.includes("12 tháng")) {
                return "installment_12";
            }
            if (label.includes("9 tháng")) {
                return "installment_9";
            }
            if (label.includes("6 tháng")) {
                return "installment_6";
            }
            return "full";
        },
        prepareContractPayload() {
            this.contract.method_payment_id = this.method_payment_id;
            this.syncCardPaymentToContract();
            return this.contract;
        },
        hydratePaymentFromContract() {
            const paymentOptions = this.contract?.payment_options;
            const paymentMethodLabel =
                (typeof this.contract?.payment_option === "string"
                    ? this.contract.payment_option
                    : "") ||
                paymentOptions?.payment_method ||
                "";

            let methodIds = this.normalizeMethodPaymentIds(
                this.contract?.method_payment_id
            );
            if (!methodIds.length) {
                methodIds = this.parseMethodPaymentIdsFromLabel(paymentMethodLabel);
            }

            this.isHydratingPayment = true;
            this.method_payment_id = methodIds;

            if (methodIds.includes(4)) {
                this.cardPaymentPlan =
                    this.parseCardPaymentPlanFromLabel(paymentMethodLabel);
                this.isSacombank = Boolean(
                    this.contract?.is_sacombank ||
                    paymentOptions?.is_sacombank ||
                    paymentOptions?.installment_bank === 'sacombank' ||
                    paymentMethodLabel.includes("Sacombank")
                );
                this.contract.is_sacombank = this.isSacombank ? 1 : 0;
                this.contract.installment_bank = this.isSacombank ? "sacombank" : null;
                this.contract.installment_months = this.isSacombank ? this.getCardInstallmentMonths() : null;
                const amount = Number(
                    this.contract.payment_amount ||
                        paymentOptions?.payment_amount ||
                        0
                );
                this.cardPaymentAmount = amount;
                this.cardPaymentAmountInput = amount
                    ? amount.toLocaleString("vi-VN")
                    : "";
                if (
                    paymentOptions?.installments_number != null &&
                    paymentOptions.installments_number !== ""
                ) {
                    this.contract.installments_number =
                        paymentOptions.installments_number;
                }
            } else {
                this.isSacombank = false;
                this.contract.is_sacombank = 0;
                this.contract.installment_bank = null;
                this.contract.installment_months = null;
            }

            if (this.contract.branch_id) {
                this.handleChangeMethodPayment();
            } else {
                this.syncCardPaymentToContract();
            }
            this.isHydratingPayment = false;
        },
        resetCardPaymentState() {
            this.cardPaymentPlan = "full";
            this.cardPaymentAmount = 0;
            this.cardPaymentAmountInput = "";
            this.contract.installments_number = 0;
            this.isSacombank = false;
            this.contract.is_sacombank = 0;
            this.contract.installment_bank = null;
            this.contract.installment_months = null;
        },
        buildPaymentOptionLabel(methodNames) {
            if (!this.method_payment_id.includes(4)) {
                return `${methodNames.join(", ")}`;
            }
            let cardPlanLabel = this.cardPaymentPlans.find(
                (item) => item.value === this.cardPaymentPlan
            )?.label;
            if (cardPlanLabel && this.isCardInstallmentPlan && this.isSacombank) {
                cardPlanLabel = cardPlanLabel.replace("Trả góp", "Trả góp qua Sacombank");
            }
            return `${methodNames
                .map((name) =>
                    name === "Thanh toán qua thẻ" && cardPlanLabel
                        ? `${name} - ${cardPlanLabel}`
                        : name
                )
                .join(", ")}`;
        },
        syncCardPaymentToContract(methodNames = null) {
            const selectedMethodNames = methodNames || this.methodPayment
                .filter((item) => this.method_payment_id.includes(item.id))
                .map((item) => item.name);
            this.contract.payment_option = this.buildPaymentOptionLabel(selectedMethodNames);

            if (this.method_payment_id.includes(4)) {
                this.contract.installments_number = this.cardFeePercent;
                this.contract.onepay_installment = this.cardPaymentPlan === 'full' ? 0 : (
                    this.cardPaymentPlan === 'installment_6' ? 6 : (
                        this.cardPaymentPlan === 'installment_9' ? 9 : 12
                    )
                );
                this.contract.onepay_amount = this.cardPaymentAmount;
                this.contract.onepay_card_amount = this.cardTotalAmount;
                this.contract.is_sacombank = this.isCardInstallmentPlan && this.isSacombank ? 1 : 0;
                this.contract.installment_bank = this.isCardInstallmentPlan && this.isSacombank ? "sacombank" : null;
                this.contract.installment_months = this.isCardInstallmentPlan && this.isSacombank ? this.getCardInstallmentMonths() : null;
                if (!this.method_payment_id.includes(3)) {
                    this.contract.payment_amount = this.cardPaymentAmount;
                }
            } else {
                this.contract.is_sacombank = 0;
                this.contract.installment_bank = null;
                this.contract.installment_months = null;
            }
        },
        isAmountActive(current, amount) {
            const val = parseInt(String(current ?? '').replace(/\D/g, ''), 10) || 0;
            return val === amount;
        },
        setCardAmount(amount) {
            this.cardPaymentAmountInput = amount ? Number(amount).toLocaleString('vi-VN') : '';
        },
        formatPrice(amount) {
            return (Number(amount) || 0).toLocaleString('vi-VN') + ' đ';
        },
        syncPaymentAmountByMethod() {
            this.syncCardPaymentToContract();
        },
        resolveInstallmentFeePayer() {
            if (Number(this.contract.tuition_payment_id) !== 2) {
                return null;
            }

            const voucherSources = [
                ...(this.list_promotions_selected || []),
                ...(this.contract?.list_promotions || []),
                ...(this.listVoucher || []),
            ];

            for (const voucher of voucherSources) {
                const payer = voucher?.installment_fee_payer;
                if (payer === null || payer === undefined || payer === "") {
                    continue;
                }
                const normalized = Number(payer);
                if (normalized === 1 || normalized === 2) {
                    return normalized;
                }
            }

            return null;
        },
        getDistricts() {
            this.$store.dispatch(GET_DISTRICTS, {
                province_id: this.contract.province_id
            }).then((res) => {
                if (!res.error) {
                    this.districts = res.data
                }
            }).catch((e) => {
            });
        },
        changeDistricts()
        {
            this.contract.district_id;
            this.getDistricts();
        },
        searchVoucherByTime()
        {
            this.openListVoucher();
        }
    },
    computed: {
        quickAmounts() {
            const total = Number(this.total_need) || 0;
            if (total <= 0) return [];
            const presets = [
                { key: 'full', name: 'Toàn bộ', amount: total },
                { key: 'half', name: '50%', amount: Math.round(total * 0.5) },
                { key: 'third', name: '30%', amount: Math.round(total * 0.3) },
            ];
            return presets.filter(
                (item, index, arr) => item.amount > 0 && arr.findIndex((x) => x.amount === item.amount) === index
            );
        },
        voucherPrograms() {
            return [
                { id: PERIODIC_PROMOTIONS, label: "Chương trình định kỳ", color: "#1BC5BD" },
                { id: FLASH_SALE, label: "Chương trình Flash Sale", color: "#FF8C22" },
                { id: SCHOOL_LINK, label: "Chương trình liên kết trường", color: "#3343D0" },
                { id: OTHER_SCHOOL, label: "Chương trình khuyến mãi khác", color: "#D40000" },
                { id: DIGITAL, label: "Chương trình Digital", color: "#0094FF" },
                { id: 6, label: "Chương trình vệ tinh", color: "#6C63D9" },
            ];
        },
        totalVoucherCount() {
            return this.voucherPrograms.reduce((total, program) => total + this.getVoucherList(program.id).length, 0);
        },
        isShowWarrantySummary() {
            return isWarrantyServiceCenter(this.contract.center_id) && !!this.contract.service_id && !!this.contract.service;
        },
        warrantyServiceAmount() {
            const serviceTotal = Number(this.contract.service_total);

            if (serviceTotal > 0) {
                return serviceTotal;
            }

            if (!this.contract.service) {
                return 0;
            }

            const total = Number(this.contract.total) || 0;
            const percent = Number(
                this.contract.service.percent_price != null
                    ? this.contract.service.percent_price
                    : this.contract.service.percent
            ) || 0;

            return (total * percent) / 100;
        },
        finalTotalNeed() {
            return (Number(this.total_need) || 0);
        },
        isCardInstallmentPlan() {
            return this.cardPaymentPlan !== "full";
        },
        isBankInstallmentTuition() {
            return Number(this.contract.tuition_payment_id) === 2;
        },
        visibleCardPaymentPlans() {
            if (this.isBankInstallmentTuition) {
                return this.cardPaymentPlans;
            }
            return this.cardPaymentPlans.filter((plan) => plan.value === "full");
        },
        selectedCardPlan() {
            return (
                this.cardPaymentPlans.find((item) => item.value === this.cardPaymentPlan) ||
                this.cardPaymentPlans[0]
            );
        },
        selectedInstallmentPromotion() {
            const promotions = [
                ...(this.list_promotions_selected || []),
                ...(this.contract?.list_promotions || []),
            ];

            return (
                promotions.find(
                    (item) => Number(item?.installment_fee_payer) >= 1
                ) || null
            );
        },
        installmentFeePayer() {
            return this.resolveInstallmentFeePayer();
        },
        cardFeePercent() {
            if (!this.isCardInstallmentPlan) {
                return 2;
            }

            if (this.selectedInstallmentPromotion) {
                const fee = Number(this.selectedInstallmentPromotion.installment_fee);
                return !Number.isNaN(fee) ? fee : 0;
            }

            return 0;
        },
        cardFeeRate() {
            return this.cardFeePercent / 100;
        },
        cardInstallmentFee() {
            return Math.round(this.cardPaymentAmount * this.cardFeeRate);
        },
        cardTotalAmount() {
            return this.cardPaymentAmount + this.cardInstallmentFee;
        },
        formattedCardInstallmentFee() {
            return this.cardInstallmentFee.toLocaleString("vi-VN");
        },
        formattedCardTotalAmount() {
            return this.cardTotalAmount.toLocaleString("vi-VN");
        },
        cardPaymentNotice() {
            if (this.isCardInstallmentPlan) {
                if (this.cardFeePercent > 0) {
                    return `Khách hàng thanh toán trả góp cần trả thêm phí ${this.cardFeePercent}%`;
                }
                return "Khách hàng thanh toán trả góp: phí 0%";
            }
            return "Khách hàng thanh toán trả thẳng cần trả thêm phí 2%";
        },
        numberGift() {
            return this.listGift.length;
        },
        titleDetail() {
            if (this.promotionDetail.type === TYPE_VOUCHER) {
                return "Chi tiết voucher";
            } else {
                return "Chi tiết quà tặng";
            }
        },
        titlePriceDetail() {
            if (this.promotionDetail == this.TYPE_VOUCHER) {
                return "Giảm ngay:";
            } else {
                return "Giá trị quy đổi tiền mặt:";
            }
        },
        titleDesc() {
            if (this.promotionDetail == this.TYPE_VOUCHER) {
                return "Chi tiết quà tặng :";
            } else {
                return "Mô tả voucher";
            }
        },
        disableSelectSchool() {
            if (this.contract.education_id && this.contract.province_id) {
                return true;
            }
            return false;
        },
        isShowProvince() {
            if ([THPT, DAI_HOC].includes(this.contract.education_id)) {
                return true;
            }
            return false;
        },
        isThpt() {
            if ([THCS, THPT].includes(this.contract.education_id)) {
                return true;
            }
            return false;
        },
        promotionTotal() {
            if (+this.contract.branch === this.digitalBranch) {
                return this.listVoucher.length + this.listGift.length;
            }
            return (
                this.listVoucher.length + this.listGift.length - this.allCode[DIGITAL]?.length
            );
        },
        getNextMonthDayEight() {
          const now = new Date();
          const year = now.getMonth() === 11 ? now.getFullYear() + 1 : now.getFullYear();
          const month = now.getMonth() === 11 ? 0 : now.getMonth() + 1;
          const day = "08";
          const formattedMonth = String(month + 1).padStart(2, "0");
          return `${day}/${formattedMonth}/${year}`;
        },
        getNextNowMonthDayEight() {
            const timelineValue = this.customer?.student_deposit_log?.timeline;
            const timeline = timelineValue ? new Date(timelineValue) : null;
            const year = timeline.getMonth() === 11 ? timeline.getFullYear() + 1 : timeline.getFullYear();
            const month = timeline.getMonth() === 11 ? 0 : timeline.getMonth() + 1;
            const day = "08";
            const formattedMonth = String(month + 1).padStart(2, "0");
            return `${day}-${formattedMonth}-${year}`;
        },

    },
};
</script>

<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
.el-select {
    width: 100%;
}
.video-cic {
    transform: rotate(360deg); /* Equal to rotateZ(45deg) */
    background-color: pink;
}
</style>
<style>
#voucher .el-dialog--center {
    max-width: 1180px;
}

#voucher .el-dialog__body {
    padding: 10px 20px 20px;
    text-align: left;
}

#voucher .voucher-picker__search {
    flex: 0 0 auto;
    margin: 0 0 12px;
}

#voucher .voucher-program-tabs {
    height: min(63vh, 630px);
}

#voucher .voucher-program-tabs > .el-tabs__header {
    width: 250px;
    height: 100%;
    margin-right: 12px;
    background: #f3f6ff;
}

#voucher .voucher-program-tabs .el-tabs__item {
    height: 52px;
    line-height: 52px;
    padding: 0 16px;
    text-align: left;
}

#voucher .voucher-program-tabs > .el-tabs__content,
#voucher .voucher-program-tabs .el-tab-pane {
    height: 100%;
}

#voucher .voucher-picker__list {
    height: 100%;
    overflow-y: auto;
    padding: 0 8px 16px 0;
}

#voucher .voucher-program-section + .voucher-program-section {
    margin-top: 18px;
}

#voucher .voucher-program-section h3 {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
}

#promotion .el-dialog--center {
    width: 75%;
}

#promotion .el-dialog__body {
    text-align: center;
}

@media (min-width: 1024.5px) {
    #voucher .el-dialog--center {
        width: 90%;
    }

    #promotion .el-dialog--center {
        width: 40%;
    }
}

@media (max-width: 767px) {
    #voucher .voucher-program-tabs > .el-tabs__header {
        width: 180px;
    }
}
.bg-violet {
    background-color: #472f92;
}
.letter-spacing {
    letter-spacing: 0px !important;
}
.font-size {
    font-size: 15px !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.payment-method-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.payment-option {
    display: flex;
    align-items: center;
    gap: 10px;
}

.payment-checkbox {
    white-space: nowrap;
    min-width: 120px;
}

.payment-input {
    flex: 1;
}

.card-payment-panel {
    margin-top: 14px;
    border: 1px solid #ede9fe;
    background: #fafaff;
    border-radius: 12px;
    padding: 16px 18px;
}

.card-payment-content {
    border-left: none;
    padding-left: 0;
}

.card-payment-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.card-payment-plan-group {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 14px;
    width: 100%;
}

.card-payment-plan-group .el-radio {
    display: flex;
    align-items: center;
    border: 1.5px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 14px;
    margin-right: 0;
    margin-bottom: 0;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
}

.card-payment-plan-group .el-radio:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
}

.card-payment-plan-group .el-radio.is-checked {
    border-color: #5b47e0;
    background: #f4f2ff;
}

.card-payment-plan-group .el-radio__input.is-checked .el-radio__inner {
    border-color: #5b47e0;
    background: #5b47e0;
}

.card-payment-plan-group .el-radio__input.is-checked + .el-radio__label {
    color: #3b28b6;
    font-weight: 700;
}

.card-payment-plan-group .el-radio__label {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
    padding-left: 10px;
}

.quick-amounts-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.quick-amount-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #fff;
    color: #334155;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
}

.quick-amount-pill:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
}

.quick-amount-pill.is-active {
    border: 1.5px solid #5b47e0;
    background: #f4f2ff;
    color: #5b47e0;
    font-weight: 700;
}

.quick-amount-pill .amount.underline {
    text-decoration: underline;
    text-underline-offset: 2px;
}

.quick-amount-pill.is-active .amount.underline {
    text-decoration-color: #5b47e0;
}

.card-amount-input .el-input__inner {
    border-radius: 8px;
    height: 40px;
    font-size: 14px;
    border-color: #cbd5e1;
}

.card-amount-input .el-input__inner:focus {
    border-color: #5b47e0;
}

.input-suffix-addon {
    font-weight: 700;
    color: #64748b;
    font-size: 14px;
    padding-right: 6px;
}

.card-payment-alert-box {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fffbeb;
    border: 1px solid #fef3c7;
    border-radius: 8px;
    padding: 10px 14px;
}

.card-payment-alert-box .alert-icon {
    color: #d97706;
    font-size: 16px;
    font-weight: 700;
}

.card-payment-alert-box .alert-text {
    color: #92400e;
    font-size: 13px;
    font-weight: 600;
}

.card-payment-summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.summary-card {
    border-radius: 10px;
    padding: 12px 16px;
}

.summary-card.fee-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
}

.summary-card.total-card {
    background: #f8f7ff;
    border: 1px solid #e0dbff;
}

.summary-card-title {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 4px;
}

.summary-card-value {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
}

.summary-card-value.total-value {
    font-size: 18px;
    font-weight: 800;
    color: #5b47e0;
}

.card-guide-placeholder {
    min-height: 84px;
    border: 1px dashed #dfe6f5;
    border-radius: 8px;
    background: #fafbff;
    color: #b7bcc7;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 16px;
    font-style: italic;
}</style>
